module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "right-panel-add",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Add Database")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('el-form', {
    ref: "addForm",
    staticClass: "add-form",
    attrs: {
      "model": _vm.addForm,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.resourceName,
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.resourceName
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.addForm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.type,
      "prop": "os"
    }
  }, [_c('el-select', {
    on: {
      "change": _vm.selectDefault
    },
    model: {
      value: (_vm.addForm.os),
      callback: function($$v) {
        _vm.addForm.os = $$v
      },
      expression: "addForm.os"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "MySQL",
      "value": "mysql"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "SQL Server",
      "value": "mssql"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "PostgreSQL",
      "value": "postgresql"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Oracle",
      "value": "oracle"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.ipAddress,
      "prop": "ipAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.defaultIpText
    },
    model: {
      value: (_vm.addForm.ipAddress),
      callback: function($$v) {
        _vm.addForm.ipAddress = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.ipAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.port,
      "prop": "port"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addForm.port),
      callback: function($$v) {
        _vm.addForm.port = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.port"
    }
  })], 1), _vm._v(" "), (_vm.addForm.os === 'oracle') ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.connectIdentifierType,
      "prop": "serviceNameType"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.addForm.serviceNameType),
      callback: function($$v) {
        _vm.addForm.serviceNameType = $$v
      },
      expression: "addForm.serviceNameType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Service Name",
      "value": "service_name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "SID",
      "value": "sid"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addForm.os === 'oracle') ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.connectIdentifier,
      "prop": "serviceName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.connectIdentifier
    },
    model: {
      value: (_vm.addForm.serviceName),
      callback: function($$v) {
        _vm.addForm.serviceName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.serviceName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.databaseName,
      "prop": "databaseName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.databaseName
    },
    model: {
      value: (_vm.addForm.databaseName),
      callback: function($$v) {
        _vm.addForm.databaseName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.databaseName"
    }
  }), _vm._v(" "), (_vm.supportMutipleDatabase) ? _c('p', [_c('translate', [_vm._v("Multiple database with semicolons ‘;’ ‘")]), _c('translate', {
    staticStyle: {
      "font-size": "24px",
      "vertical-align": "-webkit-baseline-middle"
    }
  }, [_vm._v("*")]), _c('translate', [_vm._v("’ indicates authorization all the database")])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.username,
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.username
    },
    model: {
      value: (_vm.addForm.username),
      callback: function($$v) {
        _vm.addForm.username = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.password,
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.attrText.password,
      "type": "password"
    },
    model: {
      value: (_vm.addForm.password),
      callback: function($$v) {
        _vm.addForm.password = $$v
      },
      expression: "addForm.password"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.btnDisabled
    },
    on: {
      "click": function($event) {
        _vm.onSubmitAddForm()
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.onCloseForm()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-509ab7fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/model/cluster-add-database.vue
// module id = 564
// module chunks = 4 5 6